import { useParams } from 'react-router-dom';

export const useLayoutDevice = () => {
    const { devId: id,  devName: name } = useParams<{devId: string, devName: string}>();
    return {
        id, name
    };
}
